/**
 * Checks if the application is running in a local development environment.
 * This is determined by checking if the hostname is localhost or a local IP address.
 * @returns {boolean} True if running locally, false otherwise
 */
export const isLocalEnvironment = (): boolean => {
  if (typeof window === 'undefined') {
    return process.env.NODE_ENV === 'development';
  }

  return Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
  );
};
